// GENERATED FILE — DO NOT EDIT
// Run `scripts/mix.sh grappa.gen_wire_types` to regenerate.
// Source: lib/grappa/**/*wire.ex + GrappaWeb.AuthJSON + GrappaWeb.BootJSON + GrappaWeb.ErrorTokens + GrappaWeb.MeJSON

// === External types (referenced by Wire modules) ===

export const ADMISSION_FLOW = [
  "login_fresh",
  "login_existing",
  "bootstrap_user",
  "bootstrap_visitor",
  "patch_network_connect",
  "visitor_reconnect",
  "admin_credential_bind",
] as const;
export type AdmissionFlow = (typeof ADMISSION_FLOW)[number];

export const CHANNEL_DIRECTORY_STATUS = [
  "fresh",
  "stale",
  "no_results",
  "unknown",
  "loading",
] as const;
export type ChannelDirectoryStatus = (typeof CHANNEL_DIRECTORY_STATUS)[number];

export const IRCAUTH_FSMAUTH_METHOD = [
  "auto",
  "sasl",
  "server_pass",
  "nickserv_identify",
  "none",
] as const;
export type IRCAuthFSMAuthMethod = (typeof IRCAUTH_FSMAUTH_METHOD)[number];

export const IRCIDENTIFIER_CASEMAPPING = ["ascii", "rfc1459", "rfc1459_strict"] as const;
export type IRCIdentifierCasemapping = (typeof IRCIDENTIFIER_CASEMAPPING)[number];

export const LIVE_INTROSPECTION_SESSION_ENTRY_DEGRADED_FIELD = [
  "joined_channels",
  "peer_address",
] as const;
export type LiveIntrospectionSessionEntryDegradedField =
  (typeof LIVE_INTROSPECTION_SESSION_ENTRY_DEGRADED_FIELD)[number];

export type NetworksCredentialAuthMethod = IRCAuthFSMAuthMethod;

export const NETWORKS_CREDENTIAL_CONNECTION_STATE = [
  "connected",
  "failing",
  "parked",
  "failed",
] as const;
export type NetworksCredentialConnectionState =
  (typeof NETWORKS_CREDENTIAL_CONNECTION_STATE)[number];

export const NETWORKS_CREDENTIAL_GENDER = ["male", "female", "nonbinary"] as const;
export type NetworksCredentialGender = (typeof NETWORKS_CREDENTIAL_GENDER)[number];

export const NETWORKS_NETWORK_SERVICES_FLAVOR = ["azzurra", "atheme", "oftc", "unknown"] as const;
export type NetworksNetworkServicesFlavor = (typeof NETWORKS_NETWORK_SERVICES_FLAVOR)[number];

export const SCROLLBACK_MESSAGE_KIND = [
  "privmsg",
  "notice",
  "action",
  "join",
  "part",
  "quit",
  "nick_change",
  "mode",
  "topic",
  "kick",
  "server_event",
] as const;
export type ScrollbackMessageKind = (typeof SCROLLBACK_MESSAGE_KIND)[number];

export const SCROLLBACK_META_TKEY = [
  "target",
  "new_nick",
  "modes",
  "args",
  "numeric",
  "severity",
  "who",
  "who_target",
  "names",
  "names_target",
  "raw_verb",
  "raw_sender",
  "raw_params",
  "sender_user",
  "sender_host",
  "sender_prefix",
  "sender_kind",
  "ctcp_verb",
  "ctcp_args",
  "ctcp_target",
  "notice_target",
  "statusmsg",
  "nick_fallback",
  "link_failure",
  "structural",
] as const;
export type ScrollbackMetaTKey = (typeof SCROLLBACK_META_TKEY)[number];

export type ScrollbackMetaT = Partial<Record<ScrollbackMetaTKey, unknown>>;

export type SessionISupportCasemapping = IRCIdentifierCasemapping;

export const SESSION_WINDOW_STATE_WINDOW_STATE = [
  "pending",
  "invited",
  "joined",
  "failed",
  "kicked",
  "parked",
] as const;
export type SessionWindowStateWindowState = (typeof SESSION_WINDOW_STATE_WINDOW_STATE)[number];

export const SESSION_LOG_EVENT = [
  "connected",
  "registered",
  "identified",
  "deidentified",
  "disconnected",
  "backoff",
  "nick_changed",
] as const;
export type SessionLogEvent = (typeof SESSION_LOG_EVENT)[number];

export const THEMES_TOKEN_MODEL_FONT_FAMILY = [
  "mono-default",
  "jetbrains-mono",
  "fira-code",
  "iosevka",
  "hack",
  "cascadia-code",
  "source-code-pro",
  "ibm-plex-mono",
] as const;
export type ThemesTokenModelFontFamily = (typeof THEMES_TOKEN_MODEL_FONT_FAMILY)[number];

export const THEMES_TOKEN_MODEL_SIZE_MODE = ["cover", "repeat"] as const;
export type ThemesTokenModelSizeMode = (typeof THEMES_TOKEN_MODEL_SIZE_MODE)[number];

export const WINDOW_COUNTS_SEVERITY = ["mention", "message", "event", "none"] as const;
export type WindowCountsSeverity = (typeof WINDOW_COUNTS_SEVERITY)[number];

// === Grappa.Accounts.AdminWire ===

export type AccountsAdminWireT = {
  id: string;
  name: string;
  is_admin: boolean;
  inserted_at: string;
  updated_at: string;
  live_session_count: number;
};

export type AccountsAdminWireIndexPayload = {
  users: AccountsAdminWireT[];
};

// === Grappa.Accounts.Wire ===

export type AccountsWireUserJson = {
  id: string;
  name: string;
  is_admin: boolean;
  inserted_at: string;
};

export type AccountsWireCredentialJson = {
  id: string;
  name: string;
};

export type AccountsWireClientTokenJson = {
  handle: string;
  label: string;
  created_at: string;
  last_seen_at: string;
  ip: string | null;
  user_agent: string | null;
};

// === Grappa.AdminEvents.Wire ===

export const ADMIN_EVENTS_WIRE_EVENT_KIND = [
  "circuit_open",
  "circuit_close",
  "capacity_reject",
  "visitor_deleted",
  "visitor_reaped",
  "visitor_share_token_minted",
  "user_share_token_minted",
  "reaper_swept",
  "upload_reaped",
  "uploads_swept",
  "session_disconnected",
  "session_terminated",
  "network_caps_updated",
  "circuit_reset",
  "cap_counts_changed",
  "user_created",
  "user_updated",
  "user_password_changed",
  "user_deleted",
  "network_created",
  "network_deleted",
  "server_added",
  "server_updated",
  "server_removed",
  "credential_bound",
  "credential_updated",
  "credential_unbound",
  "login_throttled",
  "web_session_severed",
] as const;
export type AdminEventsWireEventKind = (typeof ADMIN_EVENTS_WIRE_EVENT_KIND)[number];

export type AdminEventsWireCircuitOpenEvent = {
  kind: "circuit_open";
  network_id: number;
  network_slug: string | null;
  threshold: number;
  cooldown_ms: number;
  at: string;
};

export type AdminEventsWireCircuitCloseEvent = {
  kind: "circuit_close";
  network_id: number;
  network_slug: string | null;
  reason: "success" | "cooldown_expired";
  at: string;
};

export type AdminEventsWireCapacityRejectEvent = {
  kind: "capacity_reject";
  flow: AdmissionFlow;
  error: string;
  network_id: number;
  network_slug: string | null;
  source_ip: string | null;
  at: string;
};

export type AdminEventsWireVisitorDeletedEvent = {
  kind: "visitor_deleted";
  visitor_id: string;
  visitor_nick: string | null;
  actor_user_id: string | null;
  actor_user_name: string | null;
  at: string;
};

export type AdminEventsWireVisitorReapedEvent = {
  kind: "visitor_reaped";
  visitor_id: string;
  visitor_nick: string | null;
  at: string;
};

export type AdminEventsWireVisitorShareTokenMintedEvent = {
  kind: "visitor_share_token_minted";
  visitor_id: string;
  visitor_nick: string | null;
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export type AdminEventsWireUserShareTokenMintedEvent = {
  kind: "user_share_token_minted";
  user_id: string;
  user_name: string;
  at: string;
};

export type AdminEventsWireReaperSweptEvent = {
  kind: "reaper_swept";
  count: number;
  at: string;
};

export type AdminEventsWireUploadReapedEvent = {
  kind: "upload_reaped";
  upload_id: string;
  slug: string;
  subject_kind: "user" | "visitor";
  subject_id: string;
  at: string;
};

export type AdminEventsWireUploadsSweptEvent = {
  kind: "uploads_swept";
  count: number;
  at: string;
};

export type AdminEventsWireSessionDisconnectedEvent = {
  kind: "session_disconnected";
  subject_kind: "user" | "visitor";
  subject_id: string;
  network_id: number;
  network_slug: string | null;
  actor_user_id: string | null;
  actor_user_name: string | null;
  at: string;
};

export type AdminEventsWireSessionTerminatedEvent = {
  kind: "session_terminated";
  subject_kind: "user" | "visitor";
  subject_id: string;
  network_id: number;
  network_slug: string | null;
  actor_user_id: string | null;
  actor_user_name: string | null;
  at: string;
};

export type AdminEventsWireNetworkCapsUpdatedEvent = {
  kind: "network_caps_updated";
  network_id: number;
  network_slug: string;
  max_concurrent_visitor_sessions: number | null;
  max_concurrent_user_sessions: number | null;
  max_per_ip: number | null;
  actor_user_id: string | null;
  actor_user_name: string | null;
  at: string;
};

export type AdminEventsWireCircuitResetEvent = {
  kind: "circuit_reset";
  network_id: number;
  network_slug: string | null;
  actor_user_id: string | null;
  actor_user_name: string | null;
  at: string;
};

export type AdminEventsWireCapCountsChangedEvent = {
  kind: "cap_counts_changed";
  network_id: number;
  network_slug: string;
  visitors: number;
  users: number;
  max_concurrent_visitor_sessions: number | null;
  max_concurrent_user_sessions: number | null;
  at: string;
};

export type AdminEventsWireUserCreatedEvent = {
  kind: "user_created";
  user_id: string;
  user_name: string;
  is_admin: boolean;
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export type AdminEventsWireUserUpdatedEvent = {
  kind: "user_updated";
  user_id: string;
  user_name: string;
  is_admin: boolean;
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export type AdminEventsWireUserPasswordChangedEvent = {
  kind: "user_password_changed";
  user_id: string;
  user_name: string;
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export type AdminEventsWireUserDeletedEvent = {
  kind: "user_deleted";
  user_id: string;
  user_name: string;
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export type AdminEventsWireNetworkCreatedEvent = {
  kind: "network_created";
  network_id: number;
  network_slug: string;
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export type AdminEventsWireNetworkDeletedEvent = {
  kind: "network_deleted";
  network_id: number;
  network_slug: string;
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export type AdminEventsWireServerAddedEvent = {
  kind: "server_added";
  network_id: number;
  network_slug: string;
  server_id: number;
  host: string;
  port: number;
  tls: boolean;
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export type AdminEventsWireServerUpdatedEvent = {
  kind: "server_updated";
  network_id: number;
  network_slug: string;
  server_id: number;
  host: string;
  port: number;
  tls: boolean;
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export type AdminEventsWireServerRemovedEvent = {
  kind: "server_removed";
  network_id: number;
  network_slug: string;
  server_id: number;
  host: string;
  port: number;
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export type AdminEventsWireCredentialBoundEvent = {
  kind: "credential_bound";
  user_id: string;
  user_name: string;
  network_id: number;
  network_slug: string;
  nick: string;
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export type AdminEventsWireCredentialUpdatedEvent = {
  kind: "credential_updated";
  user_id: string;
  user_name: string;
  network_id: number;
  network_slug: string;
  session_action: "left_alone" | "stopped";
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export type AdminEventsWireCredentialUnboundEvent = {
  kind: "credential_unbound";
  user_id: string;
  user_name: string;
  network_id: number;
  network_slug: string;
  actor_user_id: string;
  actor_user_name: string;
  at: string;
};

export const ADMIN_EVENTS_WIRE_LOGIN_THROTTLE_DOOR = [
  "mode1_login",
  "visitor_login",
  "totp_login",
  "passkey_recovery",
  "passkey_login_options",
  "share_token_consume",
] as const;
export type AdminEventsWireLoginThrottleDoor =
  (typeof ADMIN_EVENTS_WIRE_LOGIN_THROTTLE_DOOR)[number];

export const ADMIN_EVENTS_WIRE_LOGIN_THROTTLE_SCOPE = ["ip", "ip_account"] as const;
export type AdminEventsWireLoginThrottleScope =
  (typeof ADMIN_EVENTS_WIRE_LOGIN_THROTTLE_SCOPE)[number];

export type AdminEventsWireLoginThrottledEvent = {
  kind: "login_throttled";
  source_ip: string | null;
  failures: number;
  window_ms: number;
  at: string;
  door?: AdminEventsWireLoginThrottleDoor;
  scope?: AdminEventsWireLoginThrottleScope;
};

export type AdminEventsWireWebSessionSeveredEvent = {
  kind: "web_session_severed";
  subject_kind: "user" | "visitor";
  subject_id: string;
  failures: number;
  window_ms: number;
  at: string;
};

export type AdminEventsWireEvent =
  | AdminEventsWireCircuitOpenEvent
  | AdminEventsWireCircuitCloseEvent
  | AdminEventsWireCapacityRejectEvent
  | AdminEventsWireVisitorDeletedEvent
  | AdminEventsWireVisitorReapedEvent
  | AdminEventsWireVisitorShareTokenMintedEvent
  | AdminEventsWireUserShareTokenMintedEvent
  | AdminEventsWireReaperSweptEvent
  | AdminEventsWireUploadReapedEvent
  | AdminEventsWireUploadsSweptEvent
  | AdminEventsWireSessionDisconnectedEvent
  | AdminEventsWireSessionTerminatedEvent
  | AdminEventsWireNetworkCapsUpdatedEvent
  | AdminEventsWireCircuitResetEvent
  | AdminEventsWireCapCountsChangedEvent
  | AdminEventsWireUserCreatedEvent
  | AdminEventsWireUserUpdatedEvent
  | AdminEventsWireUserPasswordChangedEvent
  | AdminEventsWireUserDeletedEvent
  | AdminEventsWireNetworkCreatedEvent
  | AdminEventsWireNetworkDeletedEvent
  | AdminEventsWireServerAddedEvent
  | AdminEventsWireServerUpdatedEvent
  | AdminEventsWireServerRemovedEvent
  | AdminEventsWireCredentialBoundEvent
  | AdminEventsWireCredentialUpdatedEvent
  | AdminEventsWireCredentialUnboundEvent
  | AdminEventsWireLoginThrottledEvent
  | AdminEventsWireWebSessionSeveredEvent;

// === Grappa.AdminOverview.Wire ===

export type AdminOverviewWireVisitors = {
  total: number;
  live: number;
};

export type AdminOverviewWireT = {
  sessions: number;
  visitors: AdminOverviewWireVisitors;
  hostname: string;
  loadavg: number | null;
  version: string;
};

// === Grappa.Admission.NetworkCircuit.AdminWire ===

export type AdmissionNetworkCircuitAdminWireT = {
  state: "closed" | "open";
  failure_count: number;
  window_start_ms: number;
  cooled_at_ms: number;
  retry_after_seconds: number;
};

// === Grappa.ChannelDirectory.Wire ===

export type ChannelDirectoryWireEntry = {
  name: string;
  topic: string | null;
  user_count: number;
  featured: boolean;
};

export type ChannelDirectoryWireIndexPayload = {
  entries: ChannelDirectoryWireEntry[];
  next_cursor: string | null;
  total: number;
  captured_at: string | null;
  status: ChannelDirectoryStatus;
};

// === Grappa.Cic.Wire ===

export type CicWireBundleHashPayload = {
  kind: "bundle_hash";
  hash: string;
  version?: string;
};

// === Grappa.LiveIntrospection.AdminWire ===

export type LiveIntrospectionAdminWireLiveStateJson = {
  nick: string | null;
  alive: boolean;
  pid_inspect: string;
  mailbox_len: number;
  memory_bytes: number;
  joined_channels: string[] | null;
  peer_address: string | null;
  peer_port: number | null;
  peer_name: string | null;
  introspection_degraded: LiveIntrospectionSessionEntryDegradedField[];
};

export type LiveIntrospectionAdminWireT = {
  subject_kind: "user" | "visitor";
  subject_id: string;
  subject_label: string | null;
  last_seen_at: string | null;
  network_id: number;
  live_state: LiveIntrospectionAdminWireLiveStateJson;
};

export type LiveIntrospectionAdminWireIndexPayload = {
  sessions: LiveIntrospectionAdminWireT[];
};

// === Grappa.Networks.AdminWire ===

export type NetworksAdminWireT = {
  id: number;
  slug: string;
  services_flavor: NetworksNetworkServicesFlavor | null;
  visitor_enabled: boolean;
  visitor_autoconnect: boolean;
  max_concurrent_visitor_sessions: number | null;
  max_concurrent_user_sessions: number | null;
  max_per_ip: number | null;
  inserted_at: string;
  updated_at: string;
};

// === Grappa.Networks.Credentials.AdminWire ===

export type NetworksCredentialsAdminWireLiveStateJson = {
  nick: string | null;
  alive: boolean;
  pid_inspect: string;
  mailbox_len: number;
  memory_bytes: number;
  joined_channels: string[] | null;
  introspection_degraded: LiveIntrospectionSessionEntryDegradedField[];
};

export type NetworksCredentialsAdminWireT = {
  user_id: string;
  user_name: string | null;
  network_id: number;
  network_slug: string;
  nick: string;
  ident: string | null;
  realname: string | null;
  sasl_user: string | null;
  auth_method: NetworksCredentialAuthMethod;
  auth_command_template: string | null;
  autojoin_channels: string[];
  last_joined_channels: string[];
  connection_state: NetworksCredentialConnectionState;
  connection_state_reason: string | null;
  connection_state_changed_at: string | null;
  detached_at: string | null;
  inserted_at: string;
  updated_at: string;
  last_seen_at: string | null;
  session_ip: string | null;
  live_state: NetworksCredentialsAdminWireLiveStateJson | null;
};

export type NetworksCredentialsAdminWireIndexPayload = {
  credentials: NetworksCredentialsAdminWireT[];
};

export const NETWORKS_CREDENTIALS_ADMIN_WIRE_SESSION_ACTION = [
  "left_alone",
  "stopped",
  "spawned",
  "not_spawned",
] as const;
export type NetworksCredentialsAdminWireSessionAction =
  (typeof NETWORKS_CREDENTIALS_ADMIN_WIRE_SESSION_ACTION)[number];

export const NETWORKS_CREDENTIALS_ADMIN_WIRE_SPAWN_ERROR = [
  "resolve_failed",
  "not_found",
  "ip_cap_exceeded",
  "visitor_cap_exceeded",
  "user_cap_exceeded",
  "network_circuit_open",
  "start_failed",
] as const;
export type NetworksCredentialsAdminWireSpawnError =
  (typeof NETWORKS_CREDENTIALS_ADMIN_WIRE_SPAWN_ERROR)[number];

// === Grappa.Networks.FeaturedChannels.AdminWire ===

export type NetworksFeaturedChannelsAdminWireT = {
  id: number;
  network_id: number;
  name: string;
  description: string | null;
  position: number;
  enabled: boolean;
  inserted_at: string;
  updated_at: string;
};

export type NetworksFeaturedChannelsAdminWireIndexPayload = {
  featured_channels: NetworksFeaturedChannelsAdminWireT[];
};

// === Grappa.Networks.FeaturedChannels.Wire ===

export type NetworksFeaturedChannelsWireLink = {
  name: string;
  description: string | null;
};

export type NetworksFeaturedChannelsWireIndexPayload = {
  channels: NetworksFeaturedChannelsWireLink[];
};

// === Grappa.Networks.Servers.AdminWire ===

export type NetworksServersAdminWireT = {
  id: number;
  network_id: number;
  host: string;
  port: number;
  tls: boolean;
  tls_verify: boolean;
  priority: number;
  enabled: boolean;
  source_address: string | null;
  inserted_at: string;
  updated_at: string;
};

export type NetworksServersAdminWireIndexPayload = {
  servers: NetworksServersAdminWireT[];
};

// === Grappa.Networks.Wire ===

export type NetworksWireCredentialJson = {
  network: string;
  nick: string;
  ident: string | null;
  realname: string | null;
  sasl_user: string | null;
  auth_method: NetworksCredentialAuthMethod;
  auth_command_template: string | null;
  autojoin_channels: string[];
  connection_state: NetworksCredentialConnectionState;
  connection_state_reason: string | null;
  connection_state_changed_at: string | null;
  age: string | null;
  gender: NetworksCredentialGender | null;
  location: string | null;
  languages: string | null;
  custom: string | null;
  avatar_url: string | null;
  inserted_at: string;
  updated_at: string;
};

export type NetworksWireConnectionInfo = {
  server: string;
  port: number;
  tls: boolean;
  registered: boolean;
  connected_at: string | null;
};

export type NetworksWireNetworkWithNickJson = {
  kind: "user";
  id: number;
  slug: string;
  services_flavor: NetworksNetworkServicesFlavor | null;
  nick: string;
  ident: string | null;
  realname: string | null;
  connection_state: NetworksCredentialConnectionState;
  connection_state_reason: string | null;
  connection_state_changed_at: string | null;
  connection: NetworksWireConnectionInfo | null;
  age: string | null;
  gender: NetworksCredentialGender | null;
  location: string | null;
  languages: string | null;
  custom: string | null;
  avatar_url: string | null;
  inserted_at: string;
  updated_at: string;
};

export type NetworksWireVisitorNetworkWithNickJson = {
  kind: "visitor";
  id: number;
  slug: string;
  services_flavor: NetworksNetworkServicesFlavor | null;
  nick: string;
  ident: string | null;
  realname: string | null;
  connection_state: NetworksCredentialConnectionState;
  connection_state_reason: string | null;
  connection_state_changed_at: string | null;
  connection: NetworksWireConnectionInfo | null;
  age: string | null;
  gender: NetworksCredentialGender | null;
  location: string | null;
  languages: string | null;
  custom: string | null;
  avatar_url: string | null;
  inserted_at: string;
  updated_at: string;
};

export type NetworksWireChannelJson = {
  name: string;
  joined: boolean;
  source: "autojoin" | "joined";
};

export type NetworksWireHomeNetworkRow = {
  slug: string;
  nick: string;
  connection_state: NetworksCredentialConnectionState;
  connection_state_reason: string | null;
  connection_state_changed_at: string | null;
  recoverable: boolean;
};

export type NetworksWireAvailableNetworkRow = {
  slug: string;
};

export type NetworksWireHomeData = {
  networks: NetworksWireHomeNetworkRow[];
  available_networks: NetworksWireAvailableNetworkRow[];
};

export type NetworksWireNetworkDetachedEvent = {
  kind: "network_detached";
  network_id: number;
  network_slug: string;
};

export type NetworksWireNetworkAttachedEvent = {
  kind: "network_attached";
  network_id: number;
  network_slug: string;
};

export type NetworksWireConnectionStateEvent = {
  kind: "connection_state_changed";
  user_id: string | null;
  network_id: number;
  network_slug: string;
  from: NetworksCredentialConnectionState;
  to: NetworksCredentialConnectionState;
  reason: string | null;
  at: string | null;
  network: NetworksWireHomeNetworkRow;
};

export type WireNetworksEvent =
  | NetworksWireNetworkWithNickJson
  | NetworksWireVisitorNetworkWithNickJson
  | NetworksWireNetworkDetachedEvent
  | NetworksWireNetworkAttachedEvent
  | NetworksWireConnectionStateEvent;

// === Grappa.Notify.Wire ===

export type NotifyWireEntriesMap = Record<string, NotifyWireEntry[]>;

export type NotifyWireEntry = {
  network_id: number;
  nick: string;
  added_at: string;
};

export type NotifyWireNotifyListPayload = {
  kind: "notify_list";
  networks: NotifyWireEntriesMap;
};

// === Grappa.QueryWindows.Wire ===

export type QueryWindowsWireWindowsMap = Record<string, QueryWindowsWireWindowsEntry[]>;

export type QueryWindowsWireWindowsEntry = {
  network_id: number;
  target_nick: string;
  opened_at: string;
};

export type QueryWindowsWireWindowsListPayload = {
  kind: "query_windows_list";
  windows: QueryWindowsWireWindowsMap;
};

// === Grappa.RateLimit.Wire ===

export type RateLimitWireWebSessionSeveredEvent = {
  kind: "web_session_severed";
  code: "rate_limit_flood";
};

// === Grappa.ReadCursor.Wire ===

export type ReadCursorWireReadCursorSet = {
  kind: "read_cursor_set";
  last_read_message_id: number;
  badge_count: number;
};

// === Grappa.Scrollback.Wire ===

export type ScrollbackWireT = {
  id: number;
  network: string;
  channel: string;
  server_time: number;
  kind: ScrollbackMessageKind;
  sender: string;
  body: string | null;
  meta: ScrollbackMetaT;
};

export type ScrollbackWireEvent = {
  kind: "message";
  message: ScrollbackWireT;
};

export type ScrollbackWireArchiveWireEntry = {
  target: string;
  kind: "channel" | "query";
  last_activity: number;
};

export type ScrollbackWireArchiveWireIndex = {
  archive: ScrollbackWireArchiveWireEntry[];
};

export type ScrollbackWireArchiveChangedPayload = {
  kind: "archive_changed";
  network_slug: string;
};

export type ScrollbackWireArchivePurgedPayload = {
  kind: "archive_purged";
  network_slug: string;
  target: string;
};

export type WireScrollbackEvent =
  | ScrollbackWireEvent
  | ScrollbackWireArchiveChangedPayload
  | ScrollbackWireArchivePurgedPayload;

// === Grappa.ServerSettings.Wire ===

export type ServerSettingsWireUploadView = {
  active_host: "embedded" | "litterbox";
  image_per_file_cap_bytes: number;
  video_per_file_cap_bytes: number;
  document_per_file_cap_bytes: number;
  audio_per_file_cap_bytes: number;
  global_cap_bytes: number;
  per_user_cap_bytes: number;
  per_visitor_cap_bytes: number;
  video_max_duration_seconds: number;
};

export type ServerSettingsWireChangedPayload = {
  kind: "server_settings_changed";
  upload: ServerSettingsWireUploadView;
  http_host_aliases: string[];
};

// === Grappa.Session.Wire ===

export const SESSION_WIRE_WIRE_EVENT_KIND = [
  "channels_changed",
  "own_nick_changed",
  "isupport_changed",
  "umode_changed",
  "session_identity_changed",
  "supported_umodes_changed",
  "topic_changed",
  "channel_modes_changed",
  "channel_created",
  "members_seeded",
  "names_reply",
  "who_reply",
  "server_reply",
  "joined",
  "window_pending",
  "window_invited",
  "window_invite_declined",
  "dcc_offer",
  "dcc_offer_resolved",
  "join_failed",
  "kicked",
  "away_confirmed",
  "mentions_bundle",
  "whois_bundle",
  "whois_avatar_ready",
  "peer_away",
  "invite_ack",
  "lusers_bundle",
  "whowas_bundle",
  "banlist_bundle",
  "links_bundle",
  "directory_progress",
  "directory_complete",
  "directory_failed",
  "connection_progress",
  "recover_progress",
  "recover_result",
  "presence_changed",
  "presence_error",
  "presence_snapshot",
] as const;
export type SessionWireWireEventKind = (typeof SESSION_WIRE_WIRE_EVENT_KIND)[number];

export type SessionWireWindowState = SessionWindowStateWindowState;

export type SessionWireChannelsChangedPayload = {
  kind: "channels_changed";
};

export type SessionWireOwnNickChangedPayload = {
  kind: "own_nick_changed";
  network_id: number;
  nick: string;
};

export type SessionWireIsupportChangedPayload = {
  kind: "isupport_changed";
  network_id: number;
  chanmodes_a: string[];
  chanmodes_b: string[];
  chanmodes_c: string[];
  chanmodes_d: string[];
  list_modes_queryable: string[];
  prefix: Record<string, string>;
  prefix_order: string[];
  chantypes: string[];
  casemapping: SessionISupportCasemapping;
  maxlist: Record<string, number>;
  nicklen: number | null;
  channellen: number | null;
  topiclen: number | null;
  frame_budget_base: number;
};

export type SessionWireUmodeChangedPayload = {
  kind: "umode_changed";
  network_id: number;
  modes: string[];
};

export type SessionWireSessionIdentityChangedPayload = {
  kind: "session_identity_changed";
  network_id: number;
  identified: boolean;
  account: string | null;
};

export type SessionWireSupportedUmodesChangedPayload = {
  kind: "supported_umodes_changed";
  network_id: number;
  modes: string[];
};

export type SessionWirePresenceChangedPayload = {
  kind: "presence_changed";
  network_id: number;
  nick: string;
  presence: "online" | "offline";
  initial: boolean;
  source: "monitor" | "watch" | "ison";
  ts: string;
};

export type SessionWirePresenceErrorPayload = {
  kind: "presence_error";
  network_id: number;
  reason: "list_full";
  detail: string;
};

export type SessionWirePresenceSnapshotPayload = {
  kind: "presence_snapshot";
  network_id: number;
  nicks: Record<string, "online" | "offline" | "unknown">;
};

export type SessionWireTopicEntryWire = {
  text: string | null;
  set_by: string | null;
  set_at: string | null;
};

export type SessionWireTopicChangedPayload = {
  kind: "topic_changed";
  network: string;
  channel: string;
  topic: SessionWireTopicEntryWire;
};

export type SessionWireChannelModesWire = {
  modes: string[];
  params: Record<string, string | null>;
};

export type SessionWireChannelModesChangedPayload = {
  kind: "channel_modes_changed";
  network: string;
  channel: string;
  modes: SessionWireChannelModesWire;
};

export type SessionWireChannelCreatedPayload = {
  kind: "channel_created";
  network: string;
  channel: string;
  created_at: string;
};

export type SessionWireMembersSeededPayload = {
  kind: "members_seeded";
  network: string;
  channel: string;
  members: SessionWireMember[];
};

export type SessionWireNamesReplyPayload = {
  kind: "names_reply";
  network: string;
  channel: string;
  members: SessionWireMember[];
};

export type SessionWireWhoUser = {
  nick: string;
  user: string;
  host: string;
  server: string;
  modes: string;
  hops: number | null;
  realname: string | null;
  channel: string;
};

export type SessionWireWhoReplyPayload = {
  kind: "who_reply";
  network: string;
  target: string;
  users: SessionWireWhoUser[];
};

export const SESSION_WIRE_SERVER_REPLY_SOURCE = ["info", "version", "motd", "admin"] as const;
export type SessionWireServerReplySource = (typeof SESSION_WIRE_SERVER_REPLY_SOURCE)[number];

export type SessionWireServerReplyPayload = {
  kind: "server_reply";
  network: string;
  source: SessionWireServerReplySource;
  lines: string[];
};

export type SessionWireMember = {
  nick: string;
  modes: string[];
  gender?: "male" | "female" | "nonbinary" | null;
};

export type SessionWireMembersIndexPayload = {
  members: SessionWireMember[];
};

export type SessionWireJoinedPayload = {
  kind: "joined";
  network: string;
  channel: string;
  state: "joined";
};

export type SessionWireWindowPendingPayload = {
  kind: "window_pending";
  network: string;
  channel: string;
  state: "pending";
};

export type SessionWireWindowInvitedPayload = {
  kind: "window_invited";
  network: string;
  channel: string;
  state: "invited";
  inviter: string;
};

export type SessionWireWindowInviteDeclinedPayload = {
  kind: "window_invite_declined";
  network: string;
  channel: string;
};

export type SessionWireDccOfferPayload = {
  kind: "dcc_offer";
  network: string;
  channel: string;
  offer_id: string;
  from: string;
  filename: string;
  size: number;
};

export type SessionWireDccOfferResolvedPayload = {
  kind: "dcc_offer_resolved";
  network: string;
  channel: string;
  offer_id: string;
  resolution: "accepted" | "refused" | "expired";
};

export type SessionWireJoinFailedPayload = {
  kind: "join_failed";
  network: string;
  channel: string;
  state: "failed";
  reason: string | null;
  numeric: number | null;
};

export type SessionWireKickedPayload = {
  kind: "kicked";
  network: string;
  channel: string;
  state: "kicked";
  by: string | null;
  reason: string | null;
};

export type SessionWireAwayConfirmedPayload = {
  kind: "away_confirmed";
  network: string;
  state: "present" | "away";
};

export type SessionWireMentionsBundleMessage = {
  server_time: number;
  channel: string;
  sender: string;
  body: string | null;
  kind: ScrollbackMessageKind;
};

export type SessionWireMentionsBundlePayload = {
  kind: "mentions_bundle";
  network: string;
  away_started_at: string;
  away_ended_at: string;
  away_reason: string | null;
  messages: SessionWireMentionsBundleMessage[];
};

export type SessionWireWhoisExtraLine = {
  numeric: number;
  text: string;
};

export type SessionWireWhoisBundlePayload = {
  kind: "whois_bundle";
  network: string;
  target: string;
  source: "user" | "rail";
  user: string | null;
  host: string | null;
  realname: string | null;
  server: string | null;
  server_info: string | null;
  is_operator: boolean;
  oper_text: string | null;
  idle_seconds: number | null;
  signon: number | null;
  channels: string[] | null;
  using_ssl: boolean;
  is_registered: boolean;
  is_admin: boolean;
  is_services_admin: boolean;
  is_helper: boolean;
  is_chanop: boolean;
  is_agent: boolean;
  is_java: boolean;
  umodes: string | null;
  away_message: string | null;
  actually_host: string | null;
  actually_ip: string | null;
  account: string | null;
  secure: boolean;
  secure_cipher: string | null;
  certfp: string | null;
  extra_lines: SessionWireWhoisExtraLine[] | null;
  avatar_url: string | null;
};

export type SessionWirePeerAwayPayload = {
  kind: "peer_away";
  network: string;
  peer: string;
  message: string;
};

export type SessionWireInviteAckPayload = {
  kind: "invite_ack";
  network: string;
  channel: string;
  peer: string;
};

export type SessionWireLusersBundlePayload = {
  kind: "lusers_bundle";
  network: string;
  total_users: number | null;
  invisible: number | null;
  servers: number | null;
  operators: number | null;
  unknown_connections: number | null;
  channels_formed: number | null;
  local_clients: number | null;
  local_servers: number | null;
  current_local: number | null;
  max_local: number | null;
  current_global: number | null;
  max_global: number | null;
};

export type SessionWireWhowasBundlePayload = {
  kind: "whowas_bundle";
  network: string;
  target: string;
  user: string | null;
  host: string | null;
  realname: string | null;
  server: string | null;
  logoff_time: string | null;
  not_found: boolean;
};

export type SessionWireBanlistEntry = {
  mask: string;
  setter: string | null;
  set_ts: string | null;
};

export type SessionWireBanlistBundlePayload = {
  kind: "banlist_bundle";
  network: string;
  channel: string;
  mode: string;
  entries: SessionWireBanlistEntry[];
};

export type SessionWireLinksEntry = {
  server: string;
  linked_to: string | null;
  hopcount: number | null;
  description: string | null;
};

export type SessionWireLinksBundlePayload = {
  kind: "links_bundle";
  network: string;
  mask: string | null;
  entries: SessionWireLinksEntry[];
};

export type SessionWireDirectoryProgressPayload = {
  kind: "directory_progress";
  network: string;
  count: number;
};

export type SessionWireDirectoryCompletePayload = {
  kind: "directory_complete";
  network: string;
  total: number;
};

export type SessionWireDirectoryFailedPayload = {
  kind: "directory_failed";
  network: string;
  reason: string;
};

export type SessionWireConnectionProgressPayload = {
  kind: "connection_progress";
  network: string;
  state: "connecting" | "connected";
};

export const SESSION_WIRE_RECOVER_STEP = [
  "identify",
  "register",
  "nick",
  "recover",
  "release",
] as const;
export type SessionWireRecoverStep = (typeof SESSION_WIRE_RECOVER_STEP)[number];

export const SESSION_WIRE_RECOVER_STATUS = ["running", "ok", "failed"] as const;
export type SessionWireRecoverStatus = (typeof SESSION_WIRE_RECOVER_STATUS)[number];

export const SESSION_WIRE_RECOVER_REASON = [
  "wrong_password",
  "nick_unavailable",
  "services_declined",
  "identify_unconfirmed",
] as const;
export type SessionWireRecoverReason = (typeof SESSION_WIRE_RECOVER_REASON)[number];

export type SessionWireRecoverProgressPayload = {
  kind: "recover_progress";
  network: string;
  step: SessionWireRecoverStep;
  status: SessionWireRecoverStatus;
  reason: SessionWireRecoverReason | null;
};

export const SESSION_WIRE_RECOVER_OUTCOME = ["succeeded", "failed"] as const;
export type SessionWireRecoverOutcome = (typeof SESSION_WIRE_RECOVER_OUTCOME)[number];

export type SessionWireRecoverResultPayload = {
  kind: "recover_result";
  network: string;
  outcome: SessionWireRecoverOutcome;
  reason: SessionWireRecoverReason | null;
};

export type SessionWireWhoisAvatarReadyPayload = {
  kind: "whois_avatar_ready";
  network: string;
  nick: string;
  avatar_url: string;
};

export type WireSessionEvent =
  | SessionWireChannelsChangedPayload
  | SessionWireOwnNickChangedPayload
  | SessionWireIsupportChangedPayload
  | SessionWireUmodeChangedPayload
  | SessionWireSessionIdentityChangedPayload
  | SessionWireSupportedUmodesChangedPayload
  | SessionWirePresenceChangedPayload
  | SessionWirePresenceErrorPayload
  | SessionWirePresenceSnapshotPayload
  | SessionWireTopicChangedPayload
  | SessionWireChannelModesChangedPayload
  | SessionWireChannelCreatedPayload
  | SessionWireMembersSeededPayload
  | SessionWireNamesReplyPayload
  | SessionWireWhoReplyPayload
  | SessionWireServerReplyPayload
  | SessionWireJoinedPayload
  | SessionWireWindowPendingPayload
  | SessionWireWindowInvitedPayload
  | SessionWireWindowInviteDeclinedPayload
  | SessionWireDccOfferPayload
  | SessionWireDccOfferResolvedPayload
  | SessionWireJoinFailedPayload
  | SessionWireKickedPayload
  | SessionWireAwayConfirmedPayload
  | SessionWireMentionsBundlePayload
  | SessionWireWhoisBundlePayload
  | SessionWirePeerAwayPayload
  | SessionWireInviteAckPayload
  | SessionWireLusersBundlePayload
  | SessionWireWhowasBundlePayload
  | SessionWireBanlistBundlePayload
  | SessionWireLinksBundlePayload
  | SessionWireDirectoryProgressPayload
  | SessionWireDirectoryCompletePayload
  | SessionWireDirectoryFailedPayload
  | SessionWireConnectionProgressPayload
  | SessionWireRecoverProgressPayload
  | SessionWireRecoverResultPayload
  | SessionWireWhoisAvatarReadyPayload;

// === Grappa.SessionLog.Wire ===

export type SessionLogWireT = {
  id: number;
  session_id: string;
  event: SessionLogEvent;
  subject_kind: "user" | "visitor";
  network_id: number;
  network_slug: string | null;
  nick: string | null;
  old_nick: string | null;
  reason: string | null;
  clean: boolean | null;
  duration_ms: number | null;
  delay_ms: number | null;
  attempt: number | null;
  at: string;
};

export type SessionLogWireEvent = {
  kind: "session_log_event";
  entry: SessionLogWireT;
};

export type SessionLogWireListResult = {
  session_log: SessionLogWireT[];
};

export type SessionLogWireSessionsResult = {
  session_log_sessions: SessionLogWireT[];
};

// === Grappa.SubjectSearch.AdminWire ===

export type SubjectSearchAdminWireResultJson = {
  type: "user" | "visitor";
  id: string;
  network: string | null;
  nick: string;
};

// === Grappa.Themes.Wire ===

export type ThemesWireFontFamily = ThemesTokenModelFontFamily;

export type ThemesWireBackgroundSize = ThemesTokenModelSizeMode;

export type ThemesWireT = {
  id: number;
  name: string;
  author: string;
  built_in: boolean;
  published: boolean;
  apply_count: number;
  in_use: number;
  mine: boolean;
  payload: Record<string, unknown>;
  inserted_at: string;
};

export type ThemesWireIndexPayload = {
  themes: ThemesWireT[];
};

export type ThemesWireActivePair = {
  light: ThemesWireT | null;
  dark: ThemesWireT | null;
};

// === Grappa.UserSettings.Wire ===

export type UserSettingsWireAutoAwayDebounceChangedPayload = {
  kind: "auto_away_debounce_changed";
  auto_away_debounce_seconds: number | null;
};

export type UserSettingsWireQuitPartReasonChangedPayload = {
  kind: "quit_part_reason_changed";
  quit_part_reason: string | null;
};

export type UserSettingsWireAutoAwayReasonChangedPayload = {
  kind: "auto_away_reason_changed";
  auto_away_reason: string | null;
};

export type WireUserSettingsEvent =
  | UserSettingsWireAutoAwayDebounceChangedPayload
  | UserSettingsWireQuitPartReasonChangedPayload
  | UserSettingsWireAutoAwayReasonChangedPayload;

// === Grappa.Vhosts.AdminWire ===

export type VhostsAdminWireVhostJson = {
  id: number;
  address: string;
  in_pool: boolean;
  generally_available: boolean;
  inserted_at: string;
  updated_at: string;
};

export type VhostsAdminWireGrantJson = {
  id: number;
  vhost_id: number;
  subject_type: "user" | "visitor";
  subject_id: string;
  subject_label: string | null;
};

// === Grappa.Visitors.AdminWire ===

export type VisitorsAdminWireLiveStateJson = {
  nick: string | null;
  alive: boolean;
  pid_inspect: string;
  mailbox_len: number;
  memory_bytes: number;
  joined_channels: string[] | null;
  introspection_degraded: LiveIntrospectionSessionEntryDegradedField[];
};

export type VisitorsAdminWireNetworkJson = {
  network_slug: string;
  network_id: number;
  nick: string;
  connection_state: NetworksCredentialConnectionState;
  live_state: VisitorsAdminWireLiveStateJson | null;
};

export type VisitorsAdminWireT = {
  id: string;
  expires_at: string | null;
  identified: boolean;
  ip: string | null;
  session_ip: string | null;
  inserted_at: string;
  last_seen_at: string | null;
  networks: VisitorsAdminWireNetworkJson[];
};

export type VisitorsAdminWireIndexPayload = {
  visitors: VisitorsAdminWireT[];
};

// === Grappa.Visitors.Wire ===

export type VisitorsWireCredentialJson = {
  id: string;
  registered: boolean;
  incognito: boolean;
};

export type VisitorsWireT = {
  id: string;
  expires_at: string | null;
  registered: boolean;
  incognito: boolean;
};

// === Grappa.WindowCounts.Wire ===

export type WindowCountsWireEvent = {
  kind: "window_counts";
  channel: string;
  messages: number;
  mentions: number;
  events: number;
  severity: WindowCountsSeverity;
};

// === GrappaWeb.AuthJSON ===

export type AuthJSONUserSubjectWire = {
  kind: "user";
  id: string;
  name: string;
};

export type AuthJSONVisitorSubjectWire = {
  kind: "visitor";
  id: string;
  registered: boolean;
  incognito: boolean;
};

export type AuthJSONSubjectWire = AuthJSONUserSubjectWire | AuthJSONVisitorSubjectWire;

// === GrappaWeb.BootJSON ===

export type BootJSONChannelTree = Record<string, NetworksWireChannelJson[]>;

export type BootJSONHeads = Record<string, Record<string, ScrollbackWireT[]>>;

export type BootJSONBootJson = {
  networks: NetworksWireNetworkWithNickJson | NetworksWireVisitorNetworkWithNickJson[];
  channels: BootJSONChannelTree;
  heads: BootJSONHeads;
};

// === GrappaWeb.ErrorTokens ===

export const ERROR_TOKENS_SHARED_ERROR_TOKEN = [
  "not_found",
  "forbidden",
  "invalid_line",
  "body_too_large",
] as const;
export type ErrorTokensSharedErrorToken = (typeof ERROR_TOKENS_SHARED_ERROR_TOKEN)[number];

export const ERROR_TOKENS_REST_ERROR_TOKEN = [
  ...ERROR_TOKENS_SHARED_ERROR_TOKEN,
  "bad_request",
  "unauthorized",
  "nickserv_pass_retired",
  "file_too_large",
  "metadata_strip_failed",
  "insufficient_storage",
  "unsupported_media_type",
  "invalid_setting",
  "addressing_unusable",
  "rate_limited",
  "too_many_attempts",
  "theme_cap_reached",
  "list_full",
  "invalid_mask",
  "not_raster",
  "too_large",
  "ssrf_blocked",
  "fetch_failed",
  "image_reencode_failed",
  "not_connected",
  "forbidden_vhost",
  "client_token_scope",
  "client_token_cap_reached",
  "invalid_credentials",
  "invalid_two_factor",
  "two_factor_challenge_expired",
  "already_enabled",
  "too_many_sessions",
  "network_busy",
  "network_unreachable",
  "captcha_required",
  "captcha_failed",
  "service_degraded",
  "db_unavailable",
  "malformed_nick",
  "malformed_ident",
  "password_required",
  "passkey_required",
  "passkey_not_configured",
  "password_mismatch",
  "network_not_visitor_enabled",
  "network_ambiguous",
  "network_unconfigured",
  "upstream_unreachable",
  "connect_timeout",
  "welcome_timeout",
  "session_timeout",
  "probe_timeout",
  "internal",
  "session_plan_resolve_failed",
  "contract_migrations_pending",
  "duplicate_migration_versions",
  "stale_code_path",
  "invalid_message",
  "anon_collision",
  "nick_in_use",
  "cannot_disconnect_self",
  "source_not_local",
  "already_exists",
  "already_attached",
  "credentials_present",
  "scrollback_present",
  "last_admin",
  "share_token_expired",
  "share_token_consumed",
  "not_invited",
  "not_held",
  "validation_failed",
] as const;
export type ErrorTokensRestErrorToken = (typeof ERROR_TOKENS_REST_ERROR_TOKEN)[number];

export const ERROR_TOKENS_CHANNEL_ERROR_TOKEN = [
  ...ERROR_TOKENS_SHARED_ERROR_TOKEN,
  "unknown_topic",
  "invalid_payload",
  "user_not_found",
  "network_not_found",
  "no_session",
  "not_explicit",
  "invalid_nick",
  "not_cached",
  "lookup_failed",
  "open_failed",
  "close_failed",
  "unknown_event",
  "save_failed",
  "invalid_reason",
  "invalid_mask",
  "upstream_unavailable",
  "persist_failed",
  "invalid_channel",
  "links_in_flight",
  "unsupported_list_mode",
  "nothing_to_recover",
  "already_identified",
  "recovery_in_progress",
  "rate_limited",
] as const;
export type ErrorTokensChannelErrorToken = (typeof ERROR_TOKENS_CHANNEL_ERROR_TOKEN)[number];

// === GrappaWeb.MeJSON ===

export type MeJSONReadCursors = Record<string, Record<string, number>>;

export type MeJSONUnreadCounts = Record<string, Record<string, MeJSONWindowCounts>>;

export type MeJSONWindowCounts = {
  messages: number;
  mentions: number;
  events: number;
  severity: "mention" | "message" | "event" | "none";
};

export type MeJSONUserMeJson = {
  kind: "user";
  id: string;
  name: string;
  is_admin: boolean;
  inserted_at: string;
  read_cursors: MeJSONReadCursors;
  unread_counts: MeJSONUnreadCounts;
  badge_count: number;
  home_data: NetworksWireHomeData;
};

export type MeJSONVisitorMeJson = {
  kind: "visitor";
  id: string;
  expires_at: string | null;
  registered: boolean;
  incognito: boolean;
  read_cursors: MeJSONReadCursors;
  unread_counts: MeJSONUnreadCounts;
  badge_count: number;
  home_data: NetworksWireHomeData;
};

export type MeJSONMeJson = MeJSONUserMeJson | MeJSONVisitorMeJson;
